import React from 'react'
import _ from 'lodash/fp'
import {lazyProviderInfo} from '../../components/WithProvider'
import {Load} from '../../hooks/useSuspense'
import {lazyExperts} from '../../admin/steps/finalReport/reportPages/lazyExperts'
import {Preview} from './Preview'
import { CASE_CLOSED } from '../../enums/CaseState'


const fixExperts = (loadedExperts,isExpert) => (currentIds) => {
  if (!isExpert) {
    return currentIds
  }
  return _.unionBy(_.get('expertId'),loadedExperts.map(({id})=> ({expertId:id,showEdit:true})),currentIds)
}

const PreviewForCaseRequestComponent = ({
  caseRequest,
  isExpert,
  ...props
}) => {

  if(caseRequest.state === CASE_CLOSED && caseRequest?.report?.expertReviews){

    const reportExperts = caseRequest.report.expertReviews
    
    // for each expert put specialization and resume into info object
    const adjustedExperts = reportExperts.map((expert) => {
      const {specialization, resume} = expert
      return {
        ...expert,
        info: {
          specialization,
          resume
        }
      }
    })

    return <Load value={lazyProviderInfo}>{providerInfo => {

        const studyCase = caseRequest.caseInfo
        const reportLayout = caseRequest.reportData.reportLayout
        const expertReviews = reportLayout.expertProfileDetails
          ? _.flow(
            fixExperts(adjustedExperts,isExpert),
            _.map((expertReview)=> _.assign(expertReview,(adjustedExperts||[]).find(({id}) => expertReview.expertId === id))),
            _.filter((expertReview)=> expertReview.id && !expertReview.hide),
            // filter by unique ids
            _.uniqBy(({id})=> id)
          // )(caseRequest.reportExpertReviews) // stopped using this, in order to use only caseRequest.report information.
          )(adjustedExperts) 
          : []

        // When opening the report, need to override the customColors in the reportData with the customColors in the providerInfo
        const reportData = _.update('customColors', () => providerInfo.customColors, caseRequest.reportData)

        const report = {
          additionalFields:studyCase.additionalFields,
          expertReviews,
          patientInfo: caseRequest.patientInfo,
          requestCode: caseRequest.requestCode,
          id: caseRequest.requestId,
          institutionDetails: caseRequest?.report?.institutionDetails || caseRequest.institutionDetails,
          questionsConsultant:studyCase.questionsConsultant,
          clinicalSummary:studyCase.clinicalSummary,
          caseSummary:studyCase.caseSummary,
          // reportData: caseRequest.reportData,
          reportData: reportData,
          signatures: studyCase.signatures,
          whenReturnedEpochMilli: caseRequest?.whenReturnedEpochMilli,
          ehrInfo: caseRequest.caseInfo.ehrInfo
        }

         
        const casePreferredLanguage = caseRequest.caseInfo.preferredLanguage 
        const casePreferredLanguageExistInOptions = providerInfo?.preferredLanguage?.options?.find(o => o.id == casePreferredLanguage)
        const preferredLanguage = casePreferredLanguageExistInOptions ? casePreferredLanguage : providerInfo?.preferredLanguage?.defaultLanguage ? providerInfo?.preferredLanguage?.defaultLanguage : casePreferredLanguage
        
        return <Preview
          {...props}
          report={report}
          // preferredLanguage={caseRequest.caseInfo.preferredLanguage}
          preferredLanguage={preferredLanguage}
          organization={{...providerInfo, ...providerInfo.address}}

        />
    }}</Load>

  }

  return <Load value={lazyProviderInfo}>{providerInfo => 
    <Load value={lazyExperts.use(_.union(caseRequest.reportExpertReviews.filter((r) => r.expertId > 0 && r.caseExpertId != null),isExpert ? [{expertId:''}] : []))}>{experts => {

      const studyCase = caseRequest.caseInfo
      const reportLayout = caseRequest.reportData.reportLayout

      const expertReviews = reportLayout.expertProfileDetails
        ? _.flow(
          fixExperts(experts,isExpert),
          _.map((expertReview)=> _.assign(expertReview,(experts||[]).find(({id}) => expertReview.expertId === id))),
          _.filter((expertReview)=> expertReview.id && !expertReview.hide)
        )(caseRequest.reportExpertReviews.filter((r) => r.expertId > 0 && r.caseExpertId != null))
        : []

      // When opening the report, need to override the customColors in the reportData with the customColors in the providerInfo
      const reportData = _.update('customColors', () => providerInfo.customColors, caseRequest.reportData)
      
      const report = {
        additionalFields:studyCase.additionalFields,
        expertReviews,
        patientInfo: caseRequest.patientInfo,
        requestCode: caseRequest.requestCode,
        id: caseRequest.requestId,
        institutionDetails: caseRequest?.report?.institutionDetails || caseRequest.institutionDetails,
        questionsConsultant:studyCase.questionsConsultant,
        clinicalSummary:studyCase.clinicalSummary,
        caseSummary:studyCase.caseSummary,
        // reportData: caseRequest.reportData,
        reportData: reportData,
        signatures: studyCase.signatures,
        whenReturnedEpochMilli: caseRequest?.whenReturnedEpochMilli,
        ehrInfo: caseRequest.caseInfo.ehrInfo
      }

      const casePreferredLanguage = caseRequest.caseInfo.preferredLanguage 
      const casePreferredLanguageExistInOptions = providerInfo?.preferredLanguage?.options?.find(o => o.id == casePreferredLanguage)
      const preferredLanguage = casePreferredLanguageExistInOptions ? casePreferredLanguage : providerInfo?.preferredLanguage?.defaultLanguage ? providerInfo?.preferredLanguage?.defaultLanguage : casePreferredLanguage
      
      return <Preview
        {...props}
        report={report}
        // preferredLanguage={caseRequest.caseInfo.preferredLanguage}
        preferredLanguage={preferredLanguage}
        organization={{...providerInfo, ...providerInfo.address}}

      />
    }}</Load>
  }</Load>
}

const arePreviewPropsEqual = (prevProps, nextProps) => {
  if (prevProps.isExpert !== nextProps.isExpert) return false
  if (prevProps.caseRequest === nextProps.caseRequest) return true

  const pickPreviewData = ({caseRequest}) => ({
    requestId: caseRequest?.requestId,
    state: caseRequest?.state,
    reportData: caseRequest?.reportData,
    reportExpertReviews: caseRequest?.reportExpertReviews,
    report: caseRequest?.report,
    caseInfo: caseRequest?.caseInfo,
    patientInfo: caseRequest?.patientInfo,
    institutionDetails: caseRequest?.institutionDetails
  })

  return _.isEqual(pickPreviewData(prevProps), pickPreviewData(nextProps))
}

export const PreviewForCaseRequest = React.memo(PreviewForCaseRequestComponent, arePreviewPropsEqual)
